// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts`.
export { AUTHORIZATIONS_PATH, authorizationsScreen } from './authorization.screen';
export { authorizationSearch } from './authorization.search';
export { CREATE_TEST_EMPLOYEE_PATH, createTestEmployeeScreen } from './create-test-employee.screen';
export { testToolSearch } from './create-test-employee.search';
export { DELETE_AUTHORIZATION_PATH, deleteAuthorizationScreen } from './delete-authorization.screen';
export { WARRANTY_EXECUTION_PATH, warrantyExecutionScreen } from './warranty-execution.screen';
export { warrantyExecutionSearch } from './warranty-execution.search';
export { loadDataprevEmployeeMessages } from './dataprev-employee.catalog';
export const loadDataprevEmployeeScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadDataprevEmployeeGuides = () => import('./dataprev-employee.guide');
